import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Me } from '../../model/user/me';
import { NecUrl } from '../../model/url/url';
import { Observable } from 'rxjs';
import { User } from '../../model/user/user';
import { UserPositionInfo } from '../../model/user/user-position-info';


/**
 * ç¨æ·ç¸å³åå°æ¥å£
 */
@Injectable()
export class UserInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * æ¥è¯¢å½åç»å½ç¨æ·ä¿¡æ¯
   */
  getUserInfo(url = `${NecUrl.SERVER_URL}/server/me`): Observable<User> {
    return this.http.get<User>(url);
  }

  /**
   * è·åç¨æ·ä¿¡æ¯åèä½ä¿¡æ¯ï¼è·åå¤´åurlä¹è°ç¨è¿ä¸ª)
   */
  getUserPositionInfo(userId: number, type?: string): Observable<UserPositionInfo> {
    let url;
    if (type === 'admin') {
      url = NecUrl.SERVER_URL + '/server/userAndPositions/' + userId + '?type=admin';
    } else {
      url = NecUrl.SERVER_URL + '/server/userAndPositions?type=user';
    }
    return this.http.get<UserPositionInfo>(url);
  }

  /**
   * è·åå¤ä¸ªç¨æ·ä¿¡æ¯åèä½ä¿¡æ¯
   */
  getMoreUserPositionInfo(userIds: number[], type?: string): Observable<UserPositionInfo> {
    const params = new HttpParams().set('userIds', userIds.toString()).set('type', 'userIds');
    return this.http.get<UserPositionInfo>(NecUrl.SERVER_URL + '/server/userAndPositions', { params: params });
  }

  getUserInfosByAccountIds(accountIds: number[]): Observable<Me[]> {
    accountIds = accountIds || [];
    return this.http.post<Me[]>(NecUrl.SERVER_URL + '/server/users?type=search', accountIds);
  }
}
